import MatchedContractsService from "@/api/services/matchedContracts";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    withFeeAmounts: () => (matchedContract) => {
      const storeAdditionnalFeeAmount = matchedContract.additionnalFee
        ? matchedContract.additionnalFee * (matchedContract.storeAdditionnalFee || 0)
        : null;
      const estalyAdditionnalFeeAmount = matchedContract.additionnalFee
        ? matchedContract.additionnalFee - (storeAdditionnalFeeAmount || 0)
        : null;
      return { ...matchedContract, storeAdditionnalFeeAmount, estalyAdditionnalFeeAmount };
    },
  },
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
  },
  actions: {
    async fetchIndex({ commit }, params = {}) {
      const response = await MatchedContractsService.fetchIndex(params);
      if (!response?.success) return response;
      commit("setIndex", toCamelCase(response.data).matchedContracts);
      return response;
    },
    exportCSV(_, { storeId }) {
      return MatchedContractsService.exportCSV(storeId);
    },
  },
};
